export default {
  namespaced: true,
  state: {
    selectedSampleTypes: null,
    selectedDestinationCountries: [],
    selectedOriginCountry: null,
    selectedEuropeanOriginCountry: null,
  },
  getters: {
    filtersComplete(state) {
      return (
        !!state.selectedSampleTypes &&
        !!state.selectedOriginCountry &&
        Array.isArray(state.selectedDestinationCountries) &&
        state.selectedDestinationCountries.length > 0
      );
    },
  },
  actions: {
    setSelectedSampleTypes({ commit, dispatch }, value) {
      commit('setSelectedSampleTypes', value);
      dispatch('applyFiltersIfReady');
    },
    setSelectedOriginCountry({ commit, dispatch }, value) {
      commit('setSelectedOriginCountry', value);
      dispatch('applyFiltersIfReady');
    },
    setSelectedDestinationCountries({ commit, dispatch }, value) {
      commit('setSelectedDestinationCountries', value);
      dispatch('applyFiltersIfReady');
    },
    setSelectedEuropeanOriginCountry({ commit }, value) {
      commit('setSelectedEuropeanOriginCountry', value);
    },
    applyFiltersIfReady({ state, getters, dispatch, rootState }) {
      if (!getters.filtersComplete) return;

      // aquí decides si pasar filtros completos o solo un flag
      dispatch(
        'riskAnalysis/callStoreWithFilters',
        {
          call: true,
          error: false,
          filters: {
            sampleType: state.selectedSampleTypes.id,
            originCountry: state.selectedOriginCountry,
            destinationCountries: state.selectedDestinationCountries,
            europeanOriginCountry:
              state.selectedEuropeanOriginCountry,
          },
        },
        { root: true }
      );
    },
    clearFilters({ commit }) {
      commit('clearFilters');
    },
  },
  mutations: {
    setSelectedSampleTypes(state, value) {
      state.selectedSampleTypes = value;
    },
    setSelectedOriginCountry(state, value) {
      state.selectedOriginCountry = value;
    },
    setSelectedDestinationCountries(state, value) {
      state.selectedDestinationCountries = value;
    },
    setSelectedEuropeanOriginCountry(state, value) {
      state.selectedEuropeanOriginCountry = value;
    },
    clearFilters(state) {
      state.selectedSampleTypes = null;
      state.selectedOriginCountry = null;
      state.selectedDestinationCountries = [];
      state.selectedEuropeanOriginCountry = null;
    },
  },
};
